import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common Functions
import { LoadScreen } from "../Common/LoadScreen";
import * as Feedback from "../../common/Feedback/Feedback";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as fo from "../../common/FormatFunctions";
import * as log from "../../common/Feedback/Log";
import { DeleteDialog } from "../Common/DeleteDialog";
import { ValidateDialog } from "../Common/ValidateDialog";
import { BPMToolbar } from "../Common/BPMToolbar";
import { WorkViewModel } from "./WorkViewModel";

export class Works extends Component {
  constructor() {
    super();
    this.state = {
      // DISPLAY FLAGS
      loaded: false,
      editLoaded: true,
      workChangesMade: false,
      workSelected: false,
      workEdited: false,
      workAdded: false,
      workDeleted: false,

      // DROPDOWN OPTIONS
      catalogueList: [],
      catlogueOptions: [],
      categoryList: [],
      categoryOptions: [],
      customerList: [],
      customerOptions: [],

      // DETAILS
      workList: [],
      originalEditedWork: "",
      editedWork: {},
      selectedCatalogueId: "",
      selectedCategoryId: "",
      crudlState: CrudlStatus.LIST,

      // DATA TABLE
      expandedRows: null,
      tableColumns: [],
      colOptions: [],

      // ADD PRODUCTS
      selectedProducts: [],
      productAdded: false,
      productSelected: {},
      productList: [],
      productAddModal: false,
      productExpandedRows: null,
      productTableColumns: [],
      productColOptions: []
    };

    //SET UP LOGGER AND VIEWMODEL
    this.logger = log;
    this.viewModel = new WorkViewModel(
      this.updateState,
      this.showError,
      this.showSuccess,
      this.showEmpty
    );
  }

  componentDidMount = () => {
    this.setUpColumns();
    this.setUpProductColumns();
    this.initialDataRender();
  };

  initialDataRender = async () => {
    await this.setPageData();
  };

  menuState = crudlStatus => {
    this.setState({
      menuItems: pr.getBreadcrumbMenuState(crudlStatus, "Work", "#/works")
    });
  };
  setPageData = async () => {
    this.setState({ loaded: false, editLoaded: false });

    await this.viewModel.getCustomers();
    await this.viewModel.getProducts();
    await this.viewModel.getWorks();
    await this.viewModel.getCatalogues();
    this.menuState(CrudlStatus.LIST);
    this.setState({ loaded: true, editLoaded: true });
  };

  //View Model Link Functions

  showError = (display, crudlStatus) => {
    Feedback.showError(this.growl, display, crudlStatus);
  };
  showSuccess = (display, crudlStatus) => {
    Feedback.showSuccess(this.growl, display, crudlStatus);
  };
  showEmpty = display => {
    Feedback.showEmpty(this.growl, display);
  };

  updateState = (key, value) => {
    this.setState({ [key]: value });
  };

  setUpColumns = () => {
    let localCols = [];
    localCols.push(pr.getTableColumn("id", "UniqueId"));
    localCols.push(pr.getTableColumn("clientId", "Customer"));
    localCols.push(pr.getTableColumn("status", "Status"));

    this.setState({ tableColumns: localCols });
    var colOptions = pr.getColumnOptions(localCols);
    this.setState({ colOptions: colOptions });
  };

  setUpProductColumns = () => {
    let localCols = [];
    localCols.push(pr.getTableColumn("name", "Name"));
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(pr.getTableColumn("operationalType", "Type"));

    this.setState({ productTableColumns: localCols });
    var colOptions = pr.getColumnOptions(localCols);
    this.setState({ productColOptions: colOptions });
  };

  onColumnToggle = event => {
    this.setState({ tableColumns: event.value });
  };
  onProductColumnToggle = event => {
    this.setState({ productTableColumns: event.value });
  };

  // #region Cloud

  getCategoriesFromSelectedCatalogue = async () => {
    await this.viewModel.getCategorys(this.state.selectedCatalogueId);
  };

  getStateValuesAsObject = () => {
    var externalObject = {};
    externalObject.selectedProducts = this.state.selectedProducts;
    externalObject.workBean = this.state.editedWork;

    return externalObject;
  };

  updateWork = async () => {
    this.setState({ editLoaded: false });

    var stateVariables = this.getStateValuesAsObject();
    var workResponse = await this.viewModel.executeCRUDLAction(
      CrudlStatus.UPDATE,
      stateVariables
    );

    if (workResponse.errorCode === 0) {
      this.setState({
        workEdited: false
      });
      this.updateWorkList(workResponse, CrudlStatus.UPDATE, stateVariables);
    } else {
      this.setState({ editLoaded: true });
    }
  };

  addWork = async () => {
    this.setState({ editLoaded: false });
    var stateVariables = this.getStateValuesAsObject();

    var workResponse = await this.viewModel.executeCRUDLAction(
      CrudlStatus.CREATE,
      stateVariables
    );

    if (workResponse.errorCode === 0) {
      this.setState({
        workEdited: false,
        workAdded: false
      });
      this.updateWorkList(workResponse, CrudlStatus.CREATE, stateVariables);
    } else {
      this.setState({ editLoaded: true });
    }
  };

  deleteWork = async () => {
    this.setState({ loaded: false });

    var stateVariables = this.getStateValuesAsObject();

    var workResponse = await this.viewModel.executeCRUDLAction(
      CrudlStatus.DELETE,
      stateVariables
    );

    if (workResponse.errorCode === 0) {
      this.setState({
        workSelected: false
      });

      this.updateWorkList(workResponse, CrudlStatus.DELETE, stateVariables);
    } else {
      this.setState({ loaded: true });
    }
  };
  // #endregion

  // #region ViewFunctions

  updateWorkList = (apiResponse, type, stateVariables) => {
    this.viewModel.reloadDataAfterExecute(
      this.state.workList,
      apiResponse,
      type,
      stateVariables
    );

    this.setState({
      loaded: true,
      editLoaded: true,
      editedWork: {},
      selectedProducts: []
    });
  };

  updateBean = (field, value) => {
    this.setState(prevState => ({
      editedWork: {
        // object that we want to update
        ...prevState.editedWork, // keep all other key-value pairs
        [field]: value
      }
    }));
    this.logger.info(value);
  };

  updateSelectedProductBean = (field, value) => {
    this.setState(prevState => ({
      productSelected: {
        // object that we want to update
        ...prevState.productSelected, // keep all other key-value pairs
        [field]: value
      }
    }));
  };

  updateProductSelected = (f, bean) => {
    f.preventDefault();
    this.logger.info(bean);
    var localBean = bean;
    var localProductList = fo.deepCopy(this.state.selectedProducts);
    var pojo = fo.parsePojoRow(localBean.id, localBean.quantity);
    var elementFound = false;
    localProductList.forEach(element => {
      if (element.id === localBean.id) {
        elementFound = true;
        element.quantity = (
          parseInt(element.quantity, 10) + parseInt(localBean.quantity, 10)
        ).toString();
      }
    });
    if (elementFound === false) {
      localProductList.push(localBean);
    }
    this.logger.info(pojo);

    var currentProductList = fo.deepCopy(this.state.productList);
    currentProductList.forEach(element => {
      if (element.id === localBean.id) {
        element.quantityAdded = true;
      }
    });
    this.setState({
      productSelected: {},
      productAdded: false,
      productList: currentProductList,
      selectedProducts: localProductList
    });
  };

  editWorkButton = data => {
    window.scrollTo(0, 0);
    if (this.state.workAdded === true) {
      this.setState({
        editedWork: {},
        originalEditedWork: JSON.stringify({}),
        selectedProducts: [],
        crudlState: CrudlStatus.CREATE
      });
    } else {
      this.setState({
        editedWork: data,
        originalEditedWork: JSON.stringify(data),
        workAdded: false,
        crudlState: CrudlStatus.UPDATE
      });
    }
  };

  deleteWorkButton = data => {
    this.setState({
      editedWork: data
    });
    this.setState({ workDeleted: true });
  };

  validateChanges = () => {
    this.logger.info(this.state.originalEditedWork);
    this.logger.info(this.state.editedWork);
    if (
      this.state.originalEditedWork === JSON.stringify(this.state.editedWork)
    ) {
      this.discardChanges();
    } else {
      this.setState({ workChangesMade: true });
    }
  };

  discardChanges = () => {
    if (this.state.workAdded === true) {
      this.setState({
        workSelected: false,
        workEdited: false,
        workAdded: false,
        workChangesMade: false
      });
    } else {
      this.setState({
        workSelected: true,
        workEdited: false,
        workAdded: false,
        workChangesMade: false
      });
    }
  };

  checkRequiredFields = () => {
    let disable = false;

    if (this.state.editedWork.description && this.state.editedWork.clientId) {
      disable = false;
    } else {
      disable = true;
    }

    return disable;
  };

  updatePropertiesJSON = data => {
    this.updateBean("customPropertiesJson", data);
  };

  updateImages = data => {
    this.updateBean("imageUrls", data);
  };

  updateFiles = data => {
    this.updateBean("fileUrls", data);
  };

  removeProductFromSelectedProducts = bean => {
    var localProductList = fo.deepCopy(this.state.selectedProducts);
    var updatedLocalProductList = [];
    localProductList.forEach(element => {
      if (element.id === bean.id) {
      } else {
        updatedLocalProductList.push(element);
      }
    });
    this.setState({ selectedProducts: updatedLocalProductList });
  };
  runCreate = () => {
    this.setState(
      {
        workSelected: false,
        workEdited: true,
        workAdded: true,
        selectedWork: {}
      },
      () => {
        this.editWorkButton({});
      }
    );
  };
  runCrud = create => {
    if (create === true) {
      this.addWork();
    } else {
      this.updateWork();
    }
  };

  // #endregion

  // #region View
  render() {
    const s = this.state;

    return (
      <div>
        <div
          className="ui-g dashboard"
          style={s.editLoaded === false ? { pointerEvents: "none" } : {}}
        >
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={el => (this.growl = el)}
          />
          <DeleteDialog
            header="Work"
            isVisible={s.workDeleted}
            visibleField="workDeleted"
            updateVisibility={this.updateState}
            runConfirm={this.deleteWork}
          />
          <ValidateDialog
            header="Work"
            isVisible={s.workChangesMade}
            visibleField="workChangesMade"
            updateVisibility={this.updateState}
            runConfirm={this.discardChanges}
          />
          <BPMToolbar
            menuItems={this.state.menuItems}
            home={pr.getBreadcrumbMenuHome()}
            addMode={this.state.workAdded}
            editMode={this.state.workEdited}
            tableColumns={this.state.tableColumns}
            columnOptions={this.state.colOptions}
            updateColumns={this.onColumnToggle}
            validateChanges={this.validateChanges}
            checkRequiredFields={this.checkRequiredFields}
            runCreate={this.runCreate}
            export={this.export}
            loading={this.state.editLoaded}
            runCrud={this.runCrud}
            runCrudOverride={false}
            refresh={this.setPageData}
          />

          {s.loaded === false ? (
            <LoadScreen />
          ) : (
            <div className="ui-g-12">
              {/*Editing Card*/}

              {s.workEdited === false ? (
                <label />
              ) : (
                <div>{this.getEditView()}</div>
              )}
              {/*Table*/}
              {s.workEdited === true ? (
                <label />
              ) : (
                <div> {this.getTableView()}</div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  getCreateWorkView = () => {
    return (
      <pr.TabPanel
        header="Create Job"
        disabled={this.state.detailsTabDisabled}
        style={{ width: "25%" }}
      >
        <div
          className="ui-g dashboard"
          style={
            this.state.editLoaded === false ? { pointerEvents: "none" } : {}
          }
        >
          <div className="ui-g-12 card-round">
            <div className="ui-g-12 title-round">
              <h2 className="title">Assign Jobs</h2>
            </div>
          </div>
        </div>
      </pr.TabPanel>
    );
  };

  getSchedule = () => {
    return (
      <pr.TabPanel
        header="Schedule"
        disabled={this.state.detailsTabDisabled}
        style={{ width: "25%" }}
      >
        <div
          className="ui-g dashboard"
          style={
            this.state.editLoaded === false ? { pointerEvents: "none" } : {}
          }
        >
          <div className="ui-g-12 card-round">
            <div className="ui-g-12 title-round">
              <h2 className="title">Job Schedule</h2>
            </div>
          </div>
        </div>
      </pr.TabPanel>
    );
  };

  getEditView = () => {
    return (
      <div>
        <pr.TabView
          activeIndex={this.state.activeIndex}
          onTabChange={e => this.setState({ activeIndex: e.index })}
        >
          {this.getCreateWorkView()}
          {this.getSchedule()}
        </pr.TabView>
      </div>
    );
  };

  onProductEditorValueChange = (row, field, value) => {
    let updatedList = this.state.productList;
    updatedList[row][field] = value;

    this.setState({ productList: updatedList });
  };
  onProductBodyValueChange = (row, field, value) => {
    let updatedList = this.state.productList;
    updatedList.forEach(element => {
      if (element.id === row) {
        element[field] = value;
      }
    });

    this.setState({ productList: updatedList });
  };
  onProductWorkBodyValueChange = (row, field, value) => {
    let updatedList = this.state.selectedProducts;
    updatedList.forEach(element => {
      if (element.id === row) {
        element[field] = value;
      }
    });

    this.setState({ selectedProducts: updatedList });
  };
  onProductWorkEditorValueChange = (row, field, value) => {
    let updatedList = this.state.selectedProducts;
    updatedList[row][field] = value;

    this.setState({ selectedProducts: updatedList });
  };

  productInputTextEditor = (props, field) => {
    this.logger.info("Running Quantity update");
    return (
      <pr.InputText
        type="text"
        keyfilter="int"
        value={props.rowData[field] || ""}
        onChange={e =>
          this.onProductEditorValueChange(
            props.rowIndex,
            props.field,
            e.target.value
          )
        }
      />
    );
  };
  productWorkInputTextEditor = (props, field) => {
    this.logger.info("Running Quantity update");
    return (
      <pr.InputText
        type="text"
        keyfilter="int"
        value={props.rowData[field] || ""}
        onChange={e =>
          this.onProductWorkEditorValueChange(
            props.rowIndex,
            props.field,
            e.target.value
          )
        }
      />
    );
  };

  hideProductEditor = () => {
    var currentPartList = fo.deepCopy(this.state.productList);
    currentPartList.forEach(element => {
      delete element.quantityAdded;
      delete element.quantity;
      delete element.shipTogether;
      delete element.manufactureTogether;
    });
    this.setState({
      productList: currentPartList,
      productAddModal: false
    });
  };

  productSelectionTemplate = bean => {
    if (!bean) {
      return;
    }
    return (
      <div>
        <div className="ui-g-12 card-round">
          <div className="ui-g-12">
            {/*Empty div for spacing*/}
            <label />
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Name: </b>
              <label>{bean.name || "Not Set"}</label>
            </div>
            <div className="ui-g-6">
              <b>Short Description: </b>
              <label>{bean.shortDescription || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Long Description: </b>
              <label>{bean.longDescription || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Type: </b>
              <label>{bean.operationalType || "Not Set"}</label>
            </div>
            <div className="ui-g-6">
              <b>Stock Type: </b>
              <label>{bean.stockType || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>SKU: </b>
              <label>{bean.sku || "Not Set"}</label>
            </div>
            <div className="ui-g-6">
              <b>Price: </b>
              <label>{bean.price || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Cost: </b>
              <label>{bean.cost || "Not Set"}</label>
            </div>
          </div>
        </div>
      </div>
    );
  };

  getSelectionView = data => {
    var bean = data;
    let allColumns = [];
    //allColumns.push(pr.getExpanderColumn());
    let columns = this.state.tableColumns.map((col, i) => {
      return (
        <pr.Column
          key={col.field}
          field={col.field}
          header={col.header}
          sortable={col.sortable}
          filter={col.filter}
          filterMatchMode={col.filterMatchMode}
          style={col.style}
        />
      );
    });

    columns.forEach(e => {
      allColumns.push(e);
    });
    return (
      <div>
        <div className="ui-g-12 card-round">
          <div className="ui-g-12">
            {/*Empty div for spacing*/}
            <label />
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>id: </b>
              <label>{bean.id || "Not Set"}</label>
            </div>
            <div className="ui-g-6">
              <b>Purchase Work No: </b>
              <label>{bean.purchaseWorkNo || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Status: </b>
              <label>{bean.status || "Not Set"}</label>
            </div>
            <div className="ui-g-6">
              <b>Client: </b>
              <label>{bean.clientId || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Customer Reference No: </b>
              <label>{bean.customerReferenceNo || "Not Set"}</label>
            </div>
            <div className="ui-g-6">
              <b>Delivery Date: </b>
              <label>{bean.expectedDeliveryDate || "Not Set"}</label>
            </div>
          </div>

          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Cost: </b>
              <label>{bean.cost || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <pr.DataTable
              ref={el => {
                this.dt = el;
              }}
              recatalogueableColumns={false}
              selectionMode="single"
              onSelectionChange={() => {}}
              value={bean.workItemList}
              // expandedRows={this.state.categoryExpandedRows}
              // onRowToggle={e => this.setState({ categoryExpandedRows: e.data })}
              // rowExpansionTemplate={this.getCategorySelectionView}
              dataKey="id"
              emptyMessage="No Categorys"
              rows={100}
              autoLayout={true}
            >
              {allColumns}
              {/* <pr.Column
                style={{ textAlign: "center", width: "8em" }}
                body={this.actionTemplate}
              ></pr.Column> */}
            </pr.DataTable>
          </div>
        </div>
      </div>
    );
  };

  export = () => {
    this.dt.exportCSV();
  };

  productQuantityEditor = props => {
    return this.productInputTextEditor(props, "quantity");
  };
  productWorkQuantityEditor = props => {
    return this.productWorkInputTextEditor(props, "quantity");
  };

  getProductManTemplate = rowData => {
    return (
      <pr.TriStateCheckbox
        onLabel="Yes"
        offLabel="No"
        value={rowData.manufactureTogether}
        onChange={e =>
          this.onProductBodyValueChange(
            rowData.id,
            "manufactureTogether",
            e.value
          )
        }
      />
    );
  };
  getProductShipTemplate = rowData => {
    return (
      <div>
        <pr.TriStateCheckbox
          onLabel="Yes"
          offLabel="No"
          value={rowData.shipTogether}
          onChange={e =>
            this.onProductBodyValueChange(rowData.id, "shipTogether", e.value)
          }
        />
      </div>
    );
  };
  getProductWorkManTemplate = rowData => {
    this.logger.info(rowData);
    return (
      <pr.TriStateCheckbox
        onLabel="Yes"
        offLabel="No"
        value={rowData.manufactureTogether}
        onChange={e =>
          this.onProductWorkBodyValueChange(
            rowData.id,
            "manufactureTogether",
            e.value
          )
        }
      />
    );
  };
  getProductWorkShipTemplate = rowData => {
    return (
      <div>
        <pr.TriStateCheckbox
          onLabel="Yes"
          offLabel="No"
          value={rowData.shipTogether}
          onChange={e =>
            this.onProductWorkBodyValueChange(
              rowData.id,
              "shipTogether",
              e.value
            )
          }
        />
      </div>
    );
  };
  getProductAddTemplate = (rowData, column) => {
    if (
      rowData.quantity === 0 ||
      rowData.quantity === undefined ||
      rowData.quantty === ""
    ) {
      return <div></div>;
    } else {
      if (rowData.quantityAdded) {
        return (
          <div>
            <pr.Button
              type="button"
              icon="pi pi-check"
              className="p-button-success"
              onClick={() => {}}
              // onClick={() => {
              //   this.setState({ partSelected: rowData, partAdded: true });
              // }}
              style={{ marginRight: ".5em", background: "green" }}
            ></pr.Button>
          </div>
        );
      } else {
        return (
          <div>
            <pr.Button
              type="button"
              icon="pi pi-plus"
              className="p-button-success"
              onClick={f => this.updateProductSelected(f, rowData)}
              // onClick={() => {
              //   this.setState({ partSelected: rowData, partAdded: true });
              // }}
              style={{ marginRight: ".5em" }}
            ></pr.Button>
          </div>
        );
      }
    }
  };

  getProductRemoveTemplate = (rowData, column) => {
    return (
      <div>
        <pr.Button
          type="button"
          icon="pi pi-trash"
          className="p-button-success"
          onClick={e => {
            this.removeProductFromSelectedProducts(rowData);
          }}
          style={{ marginRight: ".5em" }}
        ></pr.Button>
      </div>
    );
  };

  getProductTableView = () => {
    const s = this.state;
    let allColumns = [];
    let columns = this.state.productTableColumns.map((col, i) => {
      return (
        <pr.Column
          key={col.field}
          field={col.field}
          header={col.header}
          sortable={col.sortable}
          filter={col.filter}
          filterMatchMode={col.filterMatchMode}
          style={col.style}
        />
      );
    });
    columns.push(
      <pr.Column
        field="quantity"
        editor={this.productQuantityEditor}
        header="Quantity"
        sortable={true}
        filter={true}
        style={{ overflow: "auto" }}
      />
    );
    if (this.state.editedWork.shipTogether !== true) {
      columns.push(
        <pr.Column
          key="add"
          field="shipTogether"
          header="Ship Together?"
          body={this.getProductShipTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
    }
    columns.push(
      <pr.Column
        key="add"
        field="manufactureTogether"
        header="Manufacture Together?"
        body={this.getProductManTemplate}
        style={{ textAlign: "center", width: "8em" }}
      />
    );
    columns.push(
      <pr.Column
        key="add"
        body={this.getProductAddTemplate}
        style={{ textAlign: "center", width: "8em" }}
      />
    );
    allColumns.push(pr.getExpanderColumn());
    columns.forEach(e => {
      allColumns.push(e);
    });
    let flaggedColumns = [];
    if (this.state.editedWork.shipTogether !== true) {
      flaggedColumns.push(
        <pr.Column
          key="add"
          field="shipTogether"
          header="Ship Together?"
          body={this.getProductWorkShipTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
      flaggedColumns.push(
        <pr.Column
          key="add"
          field="manufactureTogether"
          header="Manufacture Together?"
          body={this.getProductWorkManTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
    } else {
      flaggedColumns.push(
        <pr.Column
          key="add"
          field="manufactureTogether"
          header="Manufacture Together?"
          body={this.getProductWorkManTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
    }
    return (
      <div>
        <div>
          <pr.Dialog
            visible={this.state.productAddModal}
            style={{ width: "100vw" }}
            modal={true}
            onHide={e => this.hideProductEditor()}
            header="Select Products"
            blockScroll={true}
            maximizable={true}
          >
            <div className="c-dialog-overflow">
              {/* {this.partSelectionTable()} */}
              <pr.DataTable
                ref={el => {
                  this.dt = el;
                }}
                reworkableColumns={false}
                selectionMode="single"
                onSelectionChange={e => {}}
                value={s.productList}
                expandedRows={this.state.productExpandedRows}
                onRowToggle={e =>
                  this.setState({ productExpandedRows: e.data })
                }
                rowExpansionTemplate={this.productSelectionTemplate}
                dataKey="id"
                header={
                  <div>
                    <label className="header-label">Products</label>
                  </div>
                }
                emptyMessage="No Products"
                rows={100}
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
              >
                {allColumns}
              </pr.DataTable>{" "}
            </div>
          </pr.Dialog>
        </div>
        <pr.DataTable
          ref={el => {
            this.dt = el;
          }}
          reworkableColumns={false}
          selectionMode="single"
          onSelectionChange={e => {}}
          value={s.selectedProducts}
          dataKey="id"
          emptyMessage="This work contains no Products"
          rows={100}
          autoLayout={true}
          paginator={true}
          alwaysShowPaginator={true}
        >
          <pr.Column
            field="name"
            header="Name"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
          />
          <pr.Column
            field="shortDescription"
            header="Description"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
          />
          <pr.Column
            field="quantity"
            header="Quantity"
            editor={this.productWorkQuantityEditor}
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
          />
          {flaggedColumns}

          <pr.Column
            header={
              <pr.Button
                className="secondary-btn"
                icon="pi pi-plus"
                onClick={() => {
                  this.setState({
                    productAddModal: true
                  });
                }}
                style={{ float: "right" }}
              />
            }
            key="add"
            body={this.getProductRemoveTemplate}
            style={{ textAlign: "center", width: "8em" }}
          />
        </pr.DataTable>
      </div>
    );
  };

  getTableView = () => {
    const s = this.state;
    let allColumns = [];
    allColumns.push(pr.getExpanderColumn());
    let columns = this.state.tableColumns.map((col, i) => {
      return (
        <pr.Column
          key={col.field}
          field={col.field}
          header={col.header}
          sortable={col.sortable}
          filter={col.filter}
          filterMatchMode={col.filterMatchMode}
          style={col.style}
        />
      );
    });

    columns.forEach(e => {
      allColumns.push(e);
    });
    return (
      <div className="ui-g-12 card-round">
        <pr.DataTable
          ref={el => {
            this.dt = el;
          }}
          reworkableColumns={false}
          selectionMode="single"
          onSelectionChange={() => {}}
          value={s.workList}
          expandedRows={this.state.expandedRows}
          onRowToggle={e => this.setState({ expandedRows: e.data })}
          rowExpansionTemplate={this.getSelectionView}
          dataKey="id"
          header={
            <div>
              <label className="header-label">Works</label>
            </div>
          }
          emptyMessage="No Works"
          rows={100}
          autoLayout={true}
          paginator={true}
          alwaysShowPaginator={true}
        >
          {allColumns}
          {/* <pr.Column
            style={{ textAlign: "center", width: "8em" }}
            body={this.actionTemplate}
          ></pr.Column> */}
        </pr.DataTable>
      </div>
    );
  };

  editExecute = rowData => {
    this.setState(
      {
        workSelected: false,
        workEdited: true,
        workAdded: false
      },
      () => {
        this.editWorkButton(rowData);
      }
    );
  };

  deleteExecute = rowData => {
    this.deleteWorkButton(rowData);
  };

  actionTemplate = (rowData, column) => {
    return (
      <div>
        <pr.Button
          icon="pi pi-pencil"
          onClick={() => {
            this.editExecute(rowData);
          }}
          style={{ float: "middle" }}
        />
        <pr.Button
          icon="pi pi-trash"
          onClick={() => {
            this.deleteExecute(rowData);
          }}
          style={{ float: "middle" }}
        />
      </div>
    );
  };

  // #endregion
}



// WEBPACK FOOTER //
// ./src/components/Work/Works.js